import {
  PayloadAction,
  createAction,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { RootState } from "../store";

export const NB_START_ITEM = 15;
export const NB_ITEM_LOAD_MORE = 10;
export const LIST_TAB_FRIEND = ["Suggestions", "Following", "Followers"];
export type ListTabFriend = "Suggestions" | "Following" | "Followers";

interface IFriends {
  friendActiveTab?: ListTabFriend;
  totalFollowing: number;
  totalFollowers: number;
  totalFollowSuggestions: number;
}

const initialState = {
  friendActiveTab: LIST_TAB_FRIEND[0],
} as IFriends;

export const resetFriendsState = createAction("friends/resetState");

export const friendsSlice = createSlice({
  name: "friends",
  initialState: initialState,
  reducers: {
    updateFriendActiveTab: (state, action: PayloadAction<{ tab: string }>) => {
      const newFriendActiveTab = action.payload.tab.split(" ")[0];
      state.friendActiveTab = newFriendActiveTab as ListTabFriend;
    },
    updateTotalFollowers: (
      state,
      action: PayloadAction<{ totalFollowers: number }>,
    ) => {
      state.totalFollowers = action.payload.totalFollowers;
    },
    updateTotalFollowing: (
      state,
      action: PayloadAction<{ totalFollowing: number }>,
    ) => {
      state.totalFollowing = action.payload.totalFollowing;
    },
    updateTotalFollowSuggestions: (
      state,
      action: PayloadAction<{ totalFollowSuggestions: number }>,
    ) => {
      state.totalFollowSuggestions = action.payload.totalFollowSuggestions;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetFriendsState, () => initialState);
  },
});

// Action creators are generated for each case reducer function
export const {
  updateFriendActiveTab,
  updateTotalFollowers,
  updateTotalFollowing,
  updateTotalFollowSuggestions,
} = friendsSlice.actions;

export const selectFriendTabListWithCount = createSelector(
  [(state: RootState) => state],
  (state) => {
    const { totalFollowers, totalFollowing, totalFollowSuggestions } =
      state.friends;

    if (!totalFollowSuggestions)
      return [
        "Following" + (!totalFollowing ? "" : ` (${totalFollowing})`),
        "Followers" + (!totalFollowers ? "" : ` (${totalFollowers})`),
      ];
    return [
      "Suggestions",
      "Following" + (!totalFollowing ? "" : ` (${totalFollowing})`),
      "Followers" + (!totalFollowers ? "" : ` (${totalFollowers})`),
    ];
  },
);

export const selectCurrentFriendTabTitle = createSelector(
  [(state: RootState) => state],
  (state) => {
    const { totalFollowers, totalFollowing, friendActiveTab } = state.friends;
    switch (friendActiveTab) {
      case "Following":
        return "Following" + (!totalFollowing ? "" : ` (${totalFollowing})`);
      case "Followers":
        return "Followers" + (!totalFollowers ? "" : ` (${totalFollowers})`);
      default:
        return "Suggestions";
    }
  },
);

export default friendsSlice.reducer;
